@if (isInitialized) {
  <oe-modal [title]="'GENERAL.PRODUCTION'| translate" helpKey="REDIRECT.COMMON_PRODUCTION" useDefaultPrefix="false"
    isCommonWidget="true">
    <!-- total summary of AC + DC -->
    @if (productionMeters?.length > 0 && chargerComponents?.length > 0) {
      <oe-modal-line [name]="'GENERAL.TOTAL'| translate" channelAddress="_sum/ProductionActivePower"
        [converter]="CONVERT_TO_WATT">
      </oe-modal-line>
      <oe-modal-horizontal-line></oe-modal-horizontal-line>
    }
    <!-- ProductionMeters -->
    @if (productionMeters?.length === 1) {
      @for (meter of productionMeters; track meter; let i = $index) {
        <oe-electricity-meter [component]="meter"></oe-electricity-meter>
        <oe-modal-horizontal-line></oe-modal-horizontal-line>
      }
    }
    @if (productionMeters.length > 1) {
      <oe-modal-line margin_bottom="2" [converter]="CONVERT_TO_WATT"
        [name]="('GENERAL.TOTAL'| translate) + (chargerComponents.length > 0 ? '&nbsp;AC':'')"
        [channelAddress]="'_sum/ProductionAcActivePower'">
      </oe-modal-line>
      @for (phase of ['L1','L2','L3']; track phase) {
        <oe-modal-line [textIndent]="TextIndentation.SINGLE" [name]=" ('GENERAL.PHASE'| translate) + '&nbsp;' + phase"
          [channelAddress]="'_sum/ProductionAcActivePower' + phase" [converter]="CONVERT_TO_WATT">
        </oe-modal-line>
      }
      <oe-modal-horizontal-line></oe-modal-horizontal-line>
      @for (meter of productionMeters; track meter; let i = $index) {
        <oe-electricity-meter [component]="meter"></oe-electricity-meter>
        <oe-modal-horizontal-line [index]="i" [components]="productionMeters">
        </oe-modal-horizontal-line>
      }
      @if (chargerComponents.length > 0) {
        <oe-modal-horizontal-line></oe-modal-horizontal-line>
      }
    }
    <!-- Chargers -->
    @if (chargerComponents.length > 1) {
      <oe-modal-line [name]="('GENERAL.TOTAL'| translate) + (productionMeters.length > 0 ? '&nbsp;DC':'')"
        [channelAddress]="'_sum/ProductionDcActualPower'" [converter]="CONVERT_TO_WATT">
      </oe-modal-line>
      <oe-modal-horizontal-line></oe-modal-horizontal-line>
    }
    @for (component of chargerComponents; track component; let i = $index) {
      <oe-ess-charger [component]="component"></oe-ess-charger>
      <oe-modal-horizontal-line [index]="i" [components]="chargerComponents"></oe-modal-horizontal-line>
    }
    <oe-modal-info-line [info]="'EDGE.INDEX.WIDGETS.PHASES_INFO' | translate">
    </oe-modal-info-line>
  </oe-modal>
}
